import './App.css';
import Header from './components/Header/header'
import Footer from  './components/Footer/footer'
import Hero from  './components/Hero/hero'

function App() {
  return (
      <div className="App">
        <Header/>
        <Hero />
        <Footer/>
      </div>
  );
}

export default App;
